import React, {Component, ReactElement, ReactNode} from 'react'
import NatMaintenanceSettingMasterRepo from './/repository/NatMaintenanceSettingMasterRepo'
import {MESSAGE_TYPE, VALID_OR_NOT, VALID_OR_NOT_CHECK} from '../../../CodeMaster'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import {PageMainArea} from '../../../components/shared/hoc/withAdminPageTemplate'
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {StyledTableCaption, TableRowName} from '../../../styledComponents/adminPage/Table'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import styled from 'styled-components'
import {StyledDiv} from '../../../styledComponents/StyledTypeDefinitions'
import {NatGetMaintenanceForResident} from './repository/NatGetMaintenanceForResident'
import {Messages} from '../../../Messages'
import {HKConstants} from '../../../HKConstants'
import {Dialog, Table, TableBody, TableCell, TableRow} from '@mui/material'
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import NatAdminMaintenanceForResidentDialog from './NatAdminMaintenanceForResidentDialog'
import AuthorityChecker from '../../../components/AuthorityChecker'
import {Location} from 'react-router-dom'

interface LocationState {
    initialMessage: HeadingAreaMessageParams
}

interface Props {
    maintenanceSettingMasterRepo: NatMaintenanceSettingMasterRepo
    eventEmitter: EventEmitterExAdmin
    location: Location<LocationState & {registerComplete: boolean}>,
}


interface States {
    currentValidFlag: string
    currentStatusText: string
    currentVersion: number
    updateButtonText: string
    updateInfoText: string
    checkedDescriptionFlag: string
    dialogOpen: boolean
    isLoadCompleted: boolean
    registerComplete: boolean
}

class NatAdminMaintenanceForResidentPage extends Component<Props & AdminPagePropsSet, States> {


    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        let registerComplete = false
        if (this.props.location &&
            this.props.location.state &&
            this.props.location.state.registerComplete) {
            registerComplete = true
            this.props.navigate(this.props.location.pathname, {
                state: {
                    registerComplete: false,
                },
            })
        }

        this.state = {
            currentValidFlag: '',
            currentStatusText: '',
            currentVersion: 1,
            updateButtonText: '',
            updateInfoText: '',
            checkedDescriptionFlag: VALID_OR_NOT_CHECK.NOT.value,
            dialogOpen: false,
            isLoadCompleted: false,
            registerComplete,
        }

        this.onClickValidOrNotButton = this.onClickValidOrNotButton.bind(this)
        this.onChangeCheckedDescriptionFlag = this.onChangeCheckedDescriptionFlag.bind(this)
        this.onClickDialogCancelButton = this.onClickDialogCancelButton.bind(this)

    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // メンテナンス設定マスタ(居住者)取得
            const maintenanceSettingMasterResidentResponse:
                Nullable<NatGetMaintenanceForResident> = await this.props.asyncCallFunction(
                this.props.maintenanceSettingMasterRepo.getMaintenanceSettingMasterResident.bind(
                    this.props.maintenanceSettingMasterRepo),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (maintenanceSettingMasterResidentResponse &&
                maintenanceSettingMasterResidentResponse.details &&
                maintenanceSettingMasterResidentResponse.details.validFlag
            ) {
                let updateButtonText = VALID_OR_NOT.NOT.label
                let updateInfoText =
                    '居住者画面はメンテナンス中のため、アクセスができません。\n[無効]ボタンを押下するとメンテナンス状態が解除され、居住者画面へのアクセスが可能となります。'
                let currentValidFlag = VALID_OR_NOT.VALID.value
                let currentStatusText = VALID_OR_NOT.VALID.label + '(メンテナンス中)'
                const currentVersion = maintenanceSettingMasterResidentResponse.details.version

                if (maintenanceSettingMasterResidentResponse.details.validFlag === VALID_OR_NOT.NOT.value) {
                    // メンテナンス外
                    updateButtonText = VALID_OR_NOT.VALID.label
                    updateInfoText =
                        '居住者画面はメンテナンス中ではないため、アクセスができます。\n[有効]ボタンを押下するとメンテナンス状態となり、居住者画面へのアクセスが不可となります。'
                    currentValidFlag = VALID_OR_NOT.NOT.value
                    currentStatusText = VALID_OR_NOT.NOT.label + '(メンテナンス外)'
                }
                this.setState({
                    currentValidFlag,
                    currentStatusText,
                    currentVersion,
                    updateInfoText,
                    updateButtonText,
                })
            }
            this.showInitialMessage()
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        } else if (this.state.registerComplete) {
            this.setState({registerComplete: false})
            const registerCompleteMessage: HeadingAreaMessageParams = {
                title: null,
                messageLevel: MESSAGE_TYPE.INFORMATION,
                detail: Messages.IOPCC0008.toString('メンテナンス状態'),
            }
            this.props.eventEmitter.showHeadingAreaMessage(registerCompleteMessage)
            return
        }

        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }

    onClickDialogCancelButton(): void {
        this.setState({
            dialogOpen: false,
        })
    }

    onChangeCheckedDescriptionFlag(): void {
        let checkedDescriptionFlag = this.state.checkedDescriptionFlag
        if (checkedDescriptionFlag === VALID_OR_NOT_CHECK.VALID.value) {
            checkedDescriptionFlag = VALID_OR_NOT_CHECK.NOT.value
        } else {
            checkedDescriptionFlag = VALID_OR_NOT_CHECK.VALID.value
        }
        this.setState({checkedDescriptionFlag})
    }

    onClickValidOrNotButton(): void {
        this.setState({
            dialogOpen: true,
        })
    }

    renderDialog(): ReactNode {
        return <>
            <Dialog
                id={'pp-dialog'}
                open={this.state.dialogOpen}
                transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
                maxWidth={'md'}
                fullWidth={true}
            >
                {this.renderDialogComponent()}
            </Dialog>
        </>
    }

    renderDialogComponent(): ReactNode {
        const {currentValidFlag, dialogOpen, updateButtonText, currentVersion} = this.state
        if (currentValidFlag === null || dialogOpen === null || updateButtonText === null || currentVersion === null) {
            return null
        }

        return <NatAdminMaintenanceForResidentDialog
            maintenanceSettingMasterRepo={this.props.maintenanceSettingMasterRepo}
            eventEmitter={this.props.eventEmitter}
            navigate={this.props.navigate}
            location={this.props.location}
            currentValidFlag={currentValidFlag}
            currentVersion={currentVersion}
            updateButtonText={updateButtonText}
            onClickDialogCancelButton={this.onClickDialogCancelButton}
            asyncCallFunction={this.props.asyncCallFunction}
        />
    }

    renderInputFormTable(): ReactNode {
        return (
            <>
                <Table>
                    <StyledTableCaption>メンテナンスモード設定</StyledTableCaption>
                    <TableBody>
                        <TableRow>
                            <TableRowName>状態</TableRowName>
                            <TableCell colSpan={2}>
                                {this.state.currentStatusText}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName></TableRowName>
                            <TableCell>
                                <WhiteSpacePre>
                                    {this.state.updateInfoText}
                                </WhiteSpacePre>
                            </TableCell>
                            <TableCell>
                                <RightButton>
                                    <AuthorityChecker
                                        permittedAuthorities={HKConstants.CMN.AUTH.EDIT_MAINTENANCE_SETTING}>
                                        <AdminPrimaryButton
                                            disabled={false}
                                            onClick={this.onClickValidOrNotButton}
                                        >
                                            {this.state.updateButtonText}
                                        </AdminPrimaryButton>
                                    </AuthorityChecker>
                                </RightButton>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                <PageMainArea>
                    {this.renderInputFormTable()}
                    {this.renderDialog()}
                </PageMainArea>
            </>

        )
    }
}

const RightButton: StyledDiv = styled.div`
  text-align: right;
`
const WhiteSpacePre: StyledDiv = styled.div`
  white-space: pre;
`

export default createAdminPage(NatAdminMaintenanceForResidentPage)
